import React from 'react'
import { shape, bool, object } from 'prop-types'
import { Picture } from '@ycos/picture'
import { withTheme, createComponent } from '@ycos/fela'
import { createFontStyle } from '@ycos/primitives'

const Heading = ({ theme, children }) => {
  const Component = createFontStyle(
    'Heading',
    {
      type: theme.custom.loyaltyRewardsCarousel.blockTitle.type,
      tagName: 'h2',
      name: theme.custom.loyaltyRewardsCarousel.blockTitle.name
    },
    () => {
      const fontSizeOverride = theme.custom.loyaltyRewardsCarousel.blockTitle.fontSize
      return {
        color: theme.typography.colors.PrimaryBlack,
        margin: `${2 * theme.spacingMultiplier}px 0 ${theme.spacingMultiplier}px`,
        'screen-large': {
          ...(fontSizeOverride ? { fontSize: fontSizeOverride } : {})
        }
      }
    }
  )
  return <Component>{children}</Component>
}

const Text = ({ theme, children }) => {
  const Component = createFontStyle(
    'Text',
    {
      type: theme.custom.loyaltyRewardsCarousel.blockText.type,
      tagName: 'p',
      name: theme.custom.loyaltyRewardsCarousel.blockText.name
    },
    () => {
      const fontFamilyOverride = theme.custom.loyaltyRewardsCarousel.blockTitle.fontFamily

      return {
        color: theme.typography.colors.PrimaryBlack,
        marginTop: `${theme.spacingMultiplier}px`,
        marginBottom: 0,
        ...(fontFamilyOverride ? { fontFamily: fontFamilyOverride } : {})
      }
    }
  )
  return <Component>{children}</Component>
}

const ImageWrapper = createComponent('ImageWrapper', () => ({
  display: 'block'
}))

const Block = ({ item, imageSphere, imageProps, theme }) => {
  const { teaserTitle, teaserText, pictures, fetchPriority } = item

  return (
    <div>
      <ImageWrapper>
        <Picture fetchPriority={fetchPriority} images={pictures} imageSphere={imageSphere} {...imageProps} />
      </ImageWrapper>
      <Heading theme={theme}>{teaserTitle}</Heading>
      <Text theme={theme}>{teaserText}</Text>
    </div>
  )
}

Block.propTypes = {
  imageProps: shape({
    lazy: bool
  }),
  item: object
}

Block.defaultProps = {
  imageProps: {
    lazy: true
  },
  item: {}
}

export default withTheme(Block)
